export default (entities, displayedEntities, userGui) => {
	let selectedEntities = displayedEntities.map((x) => {
		return entities?.find((y) => y.entityId === x.entityId && y.checked);
	});
	let entityContacts = [];
	selectedEntities?.map((entity) => {
		let isEntityAdmins = entity?.entityAdmins?.some((x) => x.userId === userGui);
		if (!isEntityAdmins) {
			let contacts = entity?.contacts;
			entityContacts = [...entityContacts, ...contacts];
		}
	});
	let contactsSelected = selectedContacts;
	let users = [];
	contactsSelected?.map((contactId) => {
		let contact = entityContacts.find((x) => x.userId === contactId);
		if (contact !== undefined) {
			users = [...users, contact];
		}
	});
	return users;
};
